angular.module('storefront.account')
    .component('vcAccountPasswordChange', {
        templateUrl: 'themes/assets/js/account/account-password-change.tpl.liquid',
        require: {
            accountManager: '^vcAccountManager',
        },
        bindings: {
            visible: '=',
        },
        controller: ['loadingIndicatorService', function (loader) {
            const ctrl = this;

            ctrl.loader = loader;
            ctrl.passwordChangeData = {};
            ctrl.isPasswordValidByPattern = {};

            ctrl.submit = function () {
                if (!ctrl.isPasswordValidByPattern) return;

                // validation
                ctrl.errors = null;
                ctrl.error = {};

                let errorMsg = ctrl.passwordChangeData.oldPassword === ctrl.passwordChangeData.newPassword;

                ctrl.error.newPassword = errorMsg;

                let hasError = errorMsg;

                if (!hasError) {
                    errorMsg = ctrl.passwordChangeData.newPassword !== ctrl.passwordChangeData.newPassword2;
                    ctrl.error.newPassword2 = errorMsg;
                    hasError = errorMsg;
                }

                if (!hasError) {
                    ctrl.accountManager.changePassword(ctrl.passwordChangeData)
                        .then(function (result) {
                            angular.extend(ctrl, result);
                            ctrl.passwordChangeData = {};
                            ctrl.form.$setPristine();
                        });
                }
            };

            ctrl.setForm = function (frm) {
                ctrl.form = frm;
            };

            ctrl.close = function () {
                ctrl.visible = false;
            };
        }],
    });
